import { TFunction } from 'i18next';

import { IPartFinderProductTypeChanges } from 'companySettings/types';

const MAX_LISTED_NAMES = 5;

export const listNames = (names: string[]) =>
  names.length > MAX_LISTED_NAMES
    ? `${names.slice(0, MAX_LISTED_NAMES).join(', ')}, …`
    : names.join(', ');

// One line for what a save or a version changed on a product type, e.g. "Renamed … · Added 2
// attributes: …". A sync leads with the list version it took in. A save that changed nothing only
// published the draft.
export const formatProductTypeChanges = (
  changes: IPartFinderProductTypeChanges,
  t: TFunction,
  isPublish = false
) => {
  const attributes = changes?.attributes;

  if (changes?.created) {
    return t('labelPartFinderProductTypeCreated', { count: attributes?.added?.length ?? 0 });
  }

  const parts = [
    changes?.sync && t('labelPartFinderProductTypeSynced', changes.sync),
    changes?.name && t('labelPartFinderAttributeRenamed', changes.name),
    attributes?.added?.length > 0 &&
      t('labelPartFinderProductTypeAttributesAdded', {
        count: attributes.added.length,
        names: listNames(attributes.added.map((attribute) => attribute.name)),
      }),
    attributes?.removed?.length > 0 &&
      t('labelPartFinderProductTypeAttributesRemoved', {
        count: attributes.removed.length,
        names: listNames(attributes.removed.map((attribute) => attribute.name)),
      }),
    ...(attributes?.renamed ?? []).map((renamed) =>
      t('labelPartFinderProductTypeAttributeRenamed', renamed)
    ),
    attributes?.changed?.length > 0 &&
      t('labelPartFinderProductTypeAttributesChanged', {
        count: attributes.changed.length,
        names: listNames(attributes.changed.map((attribute) => attribute.name)),
      }),
    attributes?.reordered && t('labelPartFinderProductTypeAttributesReordered'),
  ].filter(Boolean);

  if (parts.length) {
    return parts.join(' · ');
  }

  return isPublish ? t('labelPartFinderAttributePublished') : t('labelNoChanges');
};
